module.exports = __webpack_public_path__ + "static/brand-logo-084e04b767bfdf9525f91e984cd52129.png";